import React, { Fragment, useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import './hero.css'

const Hero = (props) => {
  const [animate, setAnimate] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(true), 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="hero-hero">
      <div className="hero-content">
        <h1 className={`hero-title ${animate ? 'hero-animate-in' : ''}`}>
          {props.title ?? (
            <Fragment>
              <span className="hero-text1">
                Data-Driven Automation for the Built Environment
              </span>
            </Fragment>
          )}
        </h1>
        <span className={`hero-description ${animate ? 'hero-animate-in hero-delay-1' : ''}`}>
          {props.description ?? (
            <Fragment>
              <span className="hero-text2">
                Hi, I&apos;m Abhishek Palit — an architect focused on
                advancing the built environment through automation,
                sustainability, and technology.
              </span>
            </Fragment>
          )}
        </span>
        <div className={`hero-cta-group ${animate ? 'hero-animate-in hero-delay-2' : ''}`}>
          <a href="/projects" className="hero-cta-primary">
            View my projects
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
          <a href="/about" className="hero-cta-secondary">
            About me
          </a>
        </div>
      </div>
      <div className="hero-image2">
        <img
          alt={props.imageAlt1}
          src={props.imageSrc1}
          className={`hero-image3 ${animate ? 'hero-animate-in hero-delay-1' : ''}`}
        />
      </div>
    </div>
  )
}

Hero.defaultProps = {
  imageAlt1: 'Abhishek Palit',
  title: undefined,
  description: undefined,
  imageSrc1: '/abhishekimg-500w.jpeg',
  imageAlt: 'image',
  imageSrc: '/line-300w.png',
}

Hero.propTypes = {
  imageAlt1: PropTypes.string,
  title: PropTypes.element,
  description: PropTypes.element,
  imageSrc1: PropTypes.string,
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
}

export default Hero
